module.exports = __webpack_public_path__ + "img/2_235.59554df4.png";